import React, { useEffect } from 'react';
import { scrollToHashLink } from '../../ScrollUtils';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import BookDemoButton from '../../BookDemoButton';
import { ConnectorDictionaryItem, ConnectorTypeEnum, ConnectorDictionary } from './ConnectorTypes';
import OtherConnectorsElement from './OtherConnectorsElement';
import ConnectorSnippets from './ConnectorSnippets';
import {
	ConnectorIconBetaLabelBig,
	FunctionalityItemList,
	FunctionalityListItem,
	PageContent,
	PageContentH1,
	PageContentH2,
	PageWrapper,
	StickyIconWrapper,
} from './Styles';
import ConnectorScreenshots from './ConnectorScreenshots';
import BetaAlert from './BetaAlert';
import LiteAdvert from './LiteAdvert';
import ConnectorLinkToTypePages from './ConnectorLinkToTypePages';

type ConnectorLandingPageProps = {
	page: ConnectorTypeEnum;
};

const ConnectorLandingPage: React.FC<ConnectorLandingPageProps & RouteComponentProps> = (props) => {
	const item: ConnectorDictionaryItem = ConnectorDictionary[props.page];

	useEffect(() => {
		scrollToHashLink(props.location.hash);
	}, [props.location]);

	return (
		<div>
			<PageWrapper>
				<StickyIconWrapper>
					<a href={item.partnerLink} target="_blank" rel="noopener noreferrer">
						<img src={item.icon(100)} alt={item.name} width={100} />
					</a>
					{item.isBeta && <ConnectorIconBetaLabelBig>BETA</ConnectorIconBetaLabelBig>}
					<h1>{item.name}</h1>

					{item.partnerElement}

					{item.liteAdvert ? (
						<LiteAdvert userPrice={item.liteUserPrice} />
					) : (
						<BookDemoButton isForMobile={false} isBordered={true} />
					)}
				</StickyIconWrapper>

				<PageContent>
					<PageContentH1>{item.name}</PageContentH1>
					<ConnectorLinkToTypePages connectorLinkToTypes={item.connectorLinkToTypes} />
					{item.subheader ?? <PageContentH2>connect to akazio cloud archive</PageContentH2>}
					{item.blurb}

					{item.isBeta && <BetaAlert />}

					<FunctionalityItemList>
						{item.connectorFunctionalityItems.map((x) => {
							return (
								<FunctionalityListItem key={x.title}>
									<strong>{x.title}</strong> {x.text}
								</FunctionalityListItem>
							);
						})}
					</FunctionalityItemList>

					<ConnectorSnippets connectorName={item.name} list={item.connectorSnippets} />

					<ConnectorScreenshots items={item.screenshots} />

					<OtherConnectorsElement exceptForType={item.type} />
				</PageContent>
			</PageWrapper>
		</div>
	);
};

export default withRouter(ConnectorLandingPage);
